import axios from 'axios'
import handleError from './ErrorHandler.js'
import Auth from '@/lib/auth/Auth.js'

const api = process.env.VUE_APP_DAISY_API

export default {
  make (method, endpoint, params) {
    // Auth makes ajax call using this make method
    if (endpoint !== 'renew-token') {
      Auth.refreshTokenIfNearExpiration()
    }
    let config = {
      method: method,
      url: api + endpoint,
      params: null,
      data: null,
      headers: {
        'Authorization': 'Bearer ' + Auth.getJWT()
      }
    }
    if (method === 'get') {
      config.params = params
    } else {
      config.data = params
    }
    return axios(config).then((response) => {
      return response.data
    }).catch((error) => {
      return handleError(error)
    })
  },
  upload (endpoint, formData) {
    return axios.post(api + endpoint, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': 'Bearer ' + Auth.getJWT()
      }
    })
      .then((response) => {
        return response.data
      }).catch((error) => {
        return handleError(error)
      })
  }
}
